import { init as initApi, search as searchApi } from "../../service/EvaluationAnalysisService";
//アクションタイプ定義
export const INIT_SUCCESS = "EVALUATION_ANALYSIS_INIT_SUCCESS";
export const INIT_FAIL = "EVALUATION_ANALYSIS_INIT_FAIL";
export const SEARCH_SUCCESS = "EVALUATION_ANALYSIS_SEARCH_SUCCESS";
export const SEARCH_FAIL = "EVALUATION_ANALYSIS_SEARCH_FAIL";

export const init = () => dispatch => {
  initApi()
    .then(response => {
      dispatch({ type: INIT_SUCCESS, payload: { evaluationList: response.evaluationList } });
    })
    .catch(error => {
      dispatch({ type: INIT_FAIL, payload: { error: error } });
    });
};

export const search = params => dispatch => {
  searchApi(params)
    .then(response => {
      if (response.message) {
        dispatch({ type: SEARCH_FAIL, payload: { message: response.message, code: response.messageCode } });
        alert(`メッセージコード: ${response.messageCode}\r\nメッセージ：${response.message}`);
      } else {
        const rows = response.students.map((student, index) => {
          return {
            id: index,
            serialNumber: student.serialNumber,
            grade: student.grade,
            class: student.classNumber,
            number: student.number,
            name: student.name
          };
        });
  
        dispatch({ type: SEARCH_SUCCESS, payload: { rows: rows } });
      }
    })
    .catch(error => {
      dispatch({ type: SEARCH_FAIL, payload: { error: error } });
    });
};
